import * as React from 'react';

import { useIntl } from 'react-intl';

import { Header, HeaderContainer, SubText } from './history-header.styled';

const HistoryHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <HeaderContainer>
      <Header>{formatMessage({ id: 'yourCrownOrders' })}</Header>
      <SubText>{formatMessage({ id: 'viewPurchasesAndOffers' })}</SubText>
    </HeaderContainer>
  );
};

export default HistoryHeader;
